import { Registration } from '@stax-core/types-omni';
import { RegistrationAction } from './Registration.types';

export function updateRegistration(payload: Registration): RegistrationAction {
  return { type: 'UPDATE_REGISTRATION', payload };
}

export function removeRegistration(): RegistrationAction {
  return { type: 'REMOVE_REGISTRATION' };
}
